import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { Icon, check } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import Button from '../button';
import Dropdown from '../dropdown';
import Tooltip from '../tooltip';

function Option(_ref) {
  var className = _ref.className,
      isSelected = _ref.isSelected,
      selectedIconProps = _ref.selectedIconProps,
      tooltipText = _ref.tooltipText,
      additionalProps = _objectWithoutProperties(_ref, ["className", "isSelected", "selectedIconProps", "tooltipText"]);

  var optionButton = createElement(Button, _extends({
    isPressed: isSelected,
    className: classnames(className, 'components-circular-option-picker__option')
  }, additionalProps));
  return createElement("div", {
    className: "components-circular-option-picker__option-wrapper"
  }, tooltipText ? createElement(Tooltip, {
    text: tooltipText
  }, optionButton) : optionButton, isSelected && createElement(Icon, _extends({
    icon: check
  }, selectedIconProps ? selectedIconProps : {})));
}

function DropdownLinkAction(_ref2) {
  var buttonProps = _ref2.buttonProps,
      className = _ref2.className,
      dropdownProps = _ref2.dropdownProps,
      linkText = _ref2.linkText;
  return createElement(Dropdown, _extends({
    className: classnames('components-circular-option-picker__dropdown-link-action', className),
    renderToggle: function renderToggle(_ref3) {
      var isOpen = _ref3.isOpen,
          onToggle = _ref3.onToggle;
      return createElement(Button, _extends({
        "aria-expanded": isOpen,
        "aria-haspopup": "true",
        onClick: onToggle,
        isLink: true
      }, buttonProps), linkText);
    }
  }, dropdownProps));
}

function ButtonAction(_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      additionalProps = _objectWithoutProperties(_ref4, ["className", "children"]);

  return createElement(Button, _extends({
    className: classnames('components-circular-option-picker__clear', className),
    isSmall: true,
    isSecondary: true
  }, additionalProps), children);
}

export default function CircularOptionPicker(_ref5) {
  var actions = _ref5.actions,
      className = _ref5.className,
      options = _ref5.options,
      children = _ref5.children;
  return createElement("div", {
    className: classnames('components-circular-option-picker', className)
  }, createElement("div", {
    className: "components-circular-option-picker__swatches"
  }, options), children, actions && createElement("div", {
    className: "components-circular-option-picker__custom-clear-wrapper"
  }, actions));
}
CircularOptionPicker.Option = Option;
CircularOptionPicker.ButtonAction = ButtonAction;
CircularOptionPicker.DropdownLinkAction = DropdownLinkAction;
//# sourceMappingURL=index.js.map